import { useQuery } from '@tanstack/react-query';
import type { ColumnDef } from '@tanstack/react-table';
import { useMemo, useState } from 'react';

import { Btn } from '../../components/Btn';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/Table';
import { listBranches } from '../../data/fetchers';
import { canEditSystemConfig } from '../../lib/permissions';
import { useSession } from '../../stores/session';
import type { Branch } from '../../types/domain';
import { BranchFormModal } from './BranchFormModal';

export function BranchesView() {
  const user = useSession((s) => s.user);
  const canEdit = user ? canEditSystemConfig(user) : false;
  const { data: branches = [] } = useQuery({
    queryKey: ['branches'],
    queryFn: listBranches,
  });
  const [editing, setEditing] = useState<Branch | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openAdd = () => {
    setEditing(null);
    setModalOpen(true);
  };
  const openEdit = (b: Branch) => {
    setEditing(b);
    setModalOpen(true);
  };

  const columns = useMemo<ColumnDef<Branch, unknown>[]>(
    () => [
      { accessorKey: 'name', header: 'ชื่อสาขา' },
      { accessorKey: 'short', header: 'ชื่อย่อ' },
      { accessorKey: 'id', header: 'รหัส' },
      {
        id: 'go',
        header: '',
        cell: (c) => (
          <button
            className="text-primary text-sm-label"
            onClick={() => openEdit(c.row.original)}
          >
            แก้ไข
          </button>
        ),
      },
    ],
    [],
  );

  if (!canEdit) {
    return (
      <div className="bo-fade">
        <PageHeader title="ร้านค้าและสาขา" />
        <div className="bo-card">
          <EmptyState
            title="เฉพาะเจ้าของ"
            sub="การจัดการสาขาทำได้โดยผู้มีสิทธิ์ระบบเท่านั้น"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="bo-fade">
      <PageHeader
        title="ร้านค้าและสาขา"
        subtitle={`${branches.length} สาขา`}
        actions={
          <Btn kind="primary" onClick={openAdd}>
            + เพิ่มสาขา
          </Btn>
        }
      />
      <DataTable columns={columns} data={branches} />
      <BranchFormModal
        open={modalOpen}
        branch={editing}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}
